<template>
  <div class="loading-logo">
    <OIcon icon="o-logo" aria-hidden="true" :svg-class="classes" />
  </div>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon },
  props: {
    colorScheme: {
      type: String,
      default: 'base',
    },
    size: {
      type: String,
      default: 'base',
    },
  },
  setup(props) {
    const colorSchemes = {
      gray: 'text-gray-700',
      red: 'text-o-red',
      green: 'text-o-green',
      blue: 'text-o-blue',
      white: 'text-white',
      base: 'text-primary-100',
    };

    const sizes = {
      lg: 'w-12 h-12',
      md: 'w-10 h-10',
      base: 'w-8 h-8',
      sm: 'w-6 h-6',
      xs: 'w-4 h-4',
    };

    const classes = computed(() => {
      const selectedSize = sizes[props.size];
      const selectedColor = colorSchemes[props.colorScheme];
      return [selectedSize, selectedColor].filter(Boolean).join(' ');
    });
    return { classes };
  },
});
</script>

<style scoped>
.loading-logo {
  animation: loading 2s infinite;
  opacity: 1;
}
@keyframes loading {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
  }
}
</style>
